import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../api/config";
import { HTTP_STATUS } from "../../../app/constants";

const namespace = "customer";

const initialState = {
  loading: null,
  customersDetail: [],
  customerResponse: {},
  errorMessage: "",
};

//POST
export const addCustomerToServer = createAsyncThunk(
  `${namespace}/addCustomerToServer`,
  async (newCustomer, { rejectWithValue }) => {
    try {
      const response = await api.post("/customer", newCustomer, {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

// GET
export const getCustomersFromServer = createAsyncThunk(
  `${namespace}/getCustomersFromServer`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/customers", {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

//GET
export const getCustomersFromServerByPagination = createAsyncThunk(
  `${namespace}/getCustomersFromServerByPagination`,
  async ({ pageNo, rowSize }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/customerspagination?pageNo=${pageNo}&rowSize=${rowSize}`,
        {
          headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
        }
      );
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

//GET
export const getCustomersCountFromServer = createAsyncThunk(
  `${namespace}/getCustomersCountFromServer`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/customerscount", {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

// PATCH
export const updateCustomerInServer = createAsyncThunk(
  `${namespace}/updateCustomerInServer`,
  async (updatedCustomer, { rejectWithValue }) => {
    try {
      const id = parseInt(updatedCustomer.customerId);
      const response = await api.patch(`/customer/${id}`, updatedCustomer, {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

//DELETE
export const deleteCustomerFromServer = createAsyncThunk(
  `${namespace}/deleteCustomerFromServer`,
  async (existingCustomer, { rejectWithValue }) => {
    try {
      const id = parseInt(existingCustomer.customerid);
      const loginUser = existingCustomer.loginUser;
      const response = await api.patch(
        `/deletecustomer/${id}`,
        {
          params: { loginUser },
        },
        {
          headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
        }
      );
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

export const customerSlice = createSlice({
  name: namespace,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addCustomerToServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(addCustomerToServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.customerResponse = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(addCustomerToServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.customerResponse = {};
        state.errorMessage = error.errorMessage;
      })
      .addCase(getCustomersFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(getCustomersFromServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.customersList = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(getCustomersFromServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.customersList = [];
        state.errorMessage = error.errorMessage;
      })
      .addCase(getCustomersFromServerByPagination.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(
        getCustomersFromServerByPagination.fulfilled,
        (state, action) => {
          state.loading = HTTP_STATUS.FULFILLED;
          state.errorMessage = null;
        }
      )
      .addCase(
        getCustomersFromServerByPagination.rejected,
        (state, { error }) => {
          state.loading = HTTP_STATUS.REJECTED;
          state.customersList = [];
          state.errorMessage = error.message;
        }
      )
      .addCase(getCustomersCountFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(getCustomersCountFromServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.errorMessage = null;
      })
      .addCase(getCustomersCountFromServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.customersList = [];
        state.errorMessage = error.errorMessage;
      })
      .addCase(updateCustomerInServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(updateCustomerInServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.customerResponse = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(updateCustomerInServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.customerResponse = {};
        state.errorMessage = error.message;
      })
      .addCase(deleteCustomerFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(deleteCustomerFromServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.customerResponse = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(deleteCustomerFromServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.customerResponse = {};
        state.errorMessage = error.errorMessage;
      });
  },
});

export const selectAllCustomers = (state) => state.customers.customersList;
export const selectLoadingStatus = (state) => state.customers.loading;
export default customerSlice.reducer;
